export enum HeaderAction {
  PrevBtnClick = 1,
  NextBtnClick = 2,
  MonthBtnClick = 3,
  YearBtnClick = 4,
}
